import axios from 'axios'
import { put, call, takeLatest } from 'redux-saga/effects'

import apiConfig from '@services/apiConfig'

import {
  GET_DIABETES_OVERVIEW,
  GET_HYPERTENSIONANDDYSLIPIDEMIA_OVERVIEW,
  GET_LIFEHABITS_OVERVIEW,
  GET_OVERWEIGHT_OVERVIEW,
  GET_RISKS_OVERVIEW,
  GET_ENGAGEMENTBENEFICIARY_OVERVIEW,
  GET_EQUIPEMENT_OVERVIEW,

  setDiabetesOverview,
  setOverweightOverview,
  setLifeHabitsOverview,
  setHypertensionAndDyslipidemiaOverview,
  setRisksOverview,
  setEngagementBeneficiaryOverview,
  setEquipmentOverview
} from '@actions/overview'

import errorHandler from '../errorHandler'

const classPrefix = '/overview'

function* getRisksOverview({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/collections-risks-overview`,
      params,
    })
    yield put(setRisksOverview(response.data))
    callback && callback(response.data)
  } catch (error) {
    callback && callback()
    errorHandler(error)
  }
}

function* getDiabetesOverview({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/collections-diabetes-overview`,
      params,
    })
    yield put(setDiabetesOverview(response.data))
    callback && callback(response.data)
  } catch (error) {
    callback && callback()
    errorHandler(error)
  }
}

function* getEquipmentOverview({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/collections-equipment-overview`,
      params,
    })
    yield put(setEquipmentOverview(response.data))
    callback && callback(response.data)
  } catch (error) {
    callback && callback()
    errorHandler(error)
  }
}

function* getOverweightOverview({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/collections-overweight-overview`,
      params,
    })
    yield put(setOverweightOverview(response.data))
    callback && callback(response.data)
  } catch (error) {
    callback && callback()
    errorHandler(error)
  }
}

function* getLifeHabitsOverview({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/collections-lifeHabits-overview`,
      params,
    })
    yield put(setLifeHabitsOverview(response.data))
    callback && callback(response.data)
  } catch (error) {
    callback && callback()
    errorHandler(error)
  }
}

function* getHypertensionAndDyslipidemiaOverview({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/collections-hypertensionAndDyslipidemia-overview`,
      params,
    })
    yield put(setHypertensionAndDyslipidemiaOverview(response.data))
    callback && callback(response.data)
  } catch (error) {
    callback && callback()
    errorHandler(error)
  }
}

function* getEngagementBeneficiaryOverview({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/active-accounts-overview`,
      params,
    })

    yield put(setEngagementBeneficiaryOverview(response.data))
    callback && callback(response.data)
  } catch (error) {
    callback && callback()
    errorHandler(error)
  }
}

export function* getRisksOverviewSaga() {
  yield takeLatest(GET_RISKS_OVERVIEW, getRisksOverview)
}

export function* getDiabetesOverviewSaga() {
  yield takeLatest(GET_DIABETES_OVERVIEW, getDiabetesOverview)
}

export function* getOverweightOverviewSaga() {
  yield takeLatest(GET_OVERWEIGHT_OVERVIEW, getOverweightOverview)
}

export function* getLifeHabitsOverviewSaga() {
  yield takeLatest(GET_LIFEHABITS_OVERVIEW, getLifeHabitsOverview)
}

export function* getHypertensionAndDyslipidemiaOverviewSaga() {
  yield takeLatest(GET_HYPERTENSIONANDDYSLIPIDEMIA_OVERVIEW, getHypertensionAndDyslipidemiaOverview)
}

export function* getEngagementBeneficiaryOverviewSaga() {
  yield takeLatest(GET_ENGAGEMENTBENEFICIARY_OVERVIEW, getEngagementBeneficiaryOverview)
}

export function* getEquipmentOverviewSaga() {
  yield takeLatest(GET_EQUIPEMENT_OVERVIEW, getEquipmentOverview)
}
